<template lang="pug">
  //- <!-- menu with submenu -->
  //- <li v-if="menu.children" :class="{ 'active': subIsActive(menu.path), 'expand': stat =='expand' }" class="has-sub">
  //-   <a v-if="$helpers.getVisible(menu.pages)" href="#" @click.prevent.stop="expand($event)" @mouseover="mouseOver(menu.children, $event)" @mouseleave="hideFloatSubmenu">
  //-     <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
  //-     <b v-else class="caret"/>
  //-     <i v-if="menu.icon" :class="menu.icon"/>
  //-     <div v-if="menu.img" class="icon-img"><img :src="menu.img" alt="" ></div>
  //-     <span>
  //-       {{ menuTitle(menu.title) }}
  //-       <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
  //-       <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"/>
  //-     </span>
  //-   </a>
  //-   <ul :class="{ 'd-block': stat == 'expand', 'd-none': stat == 'collapse' }" :style="{ marginTop: (pageOptions.pageSidebarMinified) ? - (scrollTop + 40) + 'px' : '' }" class="sub-menu">
  //-     <template v-for="submenu in menu.children">
  //-       <template v-if="$helpers.getVisible(submenu.pages)">
  //-         <sidebar-nav-list ref="sidebarNavList" :menu="submenu" :key="submenu.path" @calcFloatSubmenu="handleCalcFloatSubmenu" @collapse-other="handleCollapseOther(submenu)"/>
  //-       </template>
  //-     </template>
  //-   </ul>
  //- </li>
  //- <!-- menu without submenu -->
  //- <router-link v-else :to="menu.path" active-class="active" tag="li" @click.native="collapseOther()">
  //-   <a :class="{ 'd-none' : $store.getters.accountStatus == 'SUSPEND' && menu.title == 'ui.new_account' }">
  //-     <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
  //-     <i v-if="menu.icon" :class="menu.icon"/>
  //-     <div v-if="menu.img" class="icon-img"><img :src="menu.img" alt="" ></div>
  //-     <span>
  //-       <span v-if="menu.title == 'ui.new_account'">{{ $t("ui.new") + ' ' + $helpers.getUplineName($store.getters.accountType-1) }}</span>
  //-       <span v-else-if="menu.title == 'ui.account_list'">{{ $helpers.getUplineName($store.getters.accountType-1) + ' ' + $t("ui.list") }}</span>
  //-       <span v-else>{{ menuTitle(menu.title) }}</span>
  //-       <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"/>
  //-       <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
  //-     </span>
  //-   </a>
  //- </router-link>
  li.has-sub(v-if="menu.children" :class="{ 'active': subIsActive(menu.path), 'expand': stat =='expand' }")
    a(v-if="$helpers.getVisible(menu.pages)" href="#" @click.prevent.stop="expand($event)" @mouseover="mouseOver(menu.children, $event)" @mouseleave="hideFloatSubmenu")
      span.badge.pull-right(v-if="menu.badge") {{ menu.badge }}
      b.caret(v-else)
      i(v-if="menu.icon" :class="menu.icon")
      .icon-img(v-if="menu.img")
        img(:src="menu.img" alt="")
      span {{ menuTitle(menu.title) }}
      span.label.label-theme(v-if="menu.label") {{ menu.label }}
      i.fa.fa-paper-plane.text-theme(v-if="menu.highlight")
    ul.sub-menu(:class="{ 'd-block': stat == 'expand', 'd-none': stat == 'collapse' }" :style="{ marginTop: (pageOptions.pageSidebarMinified) ? - (scrollTop + 40) + 'px' : '' }")
      template(v-if="menu.children")
        template(v-for="submenu in visibleChildren")
          //- sidebar-nav-list(ref="sidebarNavList" :menu="submenu" :key="submenu.path" @calcFloatSubmenu="handleCalcFloatSubmenu" @collapse-other="handleCollapseOther(submenu)")
          router-link(v-if="submenu.path" :key="submenu.path" :to="submenu.path" active-class="active" tag="li" @click.native="collapseOther()")
            a(:class="{ 'd-none' : $store.getters.accountStatus == 'SUSPEND' && submenu.title == 'ui.new_account' }")
              span.badge.pull-right(v-if="submenu.badge") {{ submenu.badge }}
              i(v-if="submenu.icon" :class="submenu.icon")
              .icon-img(v-if="submenu.img")
                img(:src="submenu.img" alt="")
              span(v-if="submenu.title == 'ui.new_account'") {{ $t("ui.new") + ' ' + $helpers.getUplineName($store.getters.accountType-1) }}
              span(v-else-if="submenu.title == 'ui.account_list'") {{ $helpers.getUplineName($store.getters.accountType-1) + ' ' + $t("ui.list") }}
              span(v-else) {{ menuTitle(submenu.title) }}
              i.fa.fa-paper-plane.text-theme(v-if="submenu.highlight")
              span.label.label-theme(v-if="submenu.label") {{ submenu.label }}


  //- template(v-else)
  //-   router-link(v-if="menu.path" :to="menu.path" active-class="active" tag="li" @click.native="collapseOther()")
  //-     a(:class="{ 'd-none' : $store.getters.accountStatus == 'SUSPEND' && menu.title == 'ui.new_account' }")
  //-       span.badge.pull-right(v-if="menu.badge") {{ menu.badge }}
  //-       i(v-if="menu.icon" :class="menu.icon")
  //-       .icon-img(v-if="menu.img")
  //-         img(:src="menu.img" alt="")
  //-       span(v-if="menu.title == 'ui.new_account'") {{ $t("ui.new") + ' ' + $helpers.getUplineName($store.getters.accountType-1) }}
  //-       span(v-else-if="menu.title == 'ui.account_list'") {{ $helpers.getUplineName($store.getters.accountType-1) + ' ' + $t("ui.list") }}
  //-       span(v-else) {{ menuTitle(menu.title) }}
  //-       i.fa.fa-paper-plane.text-theme(v-if="menu.highlight")
  //-       span.label.label-theme(v-if="menu.label") {{ menu.label }}
</template>

<script>
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '../../config/PageOptions.vue'

export default {
  name: 'SidebarNavList',
  components: {
    SidebarNavList
  },
  props: ['menu', 'scrollTop'],
  data() {
    return {
      stat: '',
      pageOptions: PageOptions
    }
  },
  computed: {
    isPartner() {
      return this.$store.getters.isPartner;
    },
    visibleChildren() {
      if (!this.menu || !this.menu.children) {
        return [];
      }
      return this.menu.children.filter(submenu => {
        if (!submenu || !submenu.path) {
          return false;
        }
        if (!this.$helpers.getVisible(submenu.pages)) {
          return false;
        }
        if (
          submenu.requirePartner &&
          (this.$store.getters.accountType != 6 || !this.isPartner)
        ) {
          return false;
        }
        return true;
      });
    }
  },
  methods: {
    mouseOver: function(data, event) {
      if (this.pageOptions.pageSidebarMinified) {
        var offset = event.target.offsetParent.getBoundingClientRect();
        var filtered = (data || []).filter(submenu => {
          if (
            submenu.requirePartner &&
            (this.$store.getters.accountType != 6 ||
              !this.$store.getters.isPartner)
          ) {
            return false;
          }
          return this.$helpers.getVisible(submenu.pages);
        });
        this.$emit('showFloatSubmenu', filtered, offset);
      }
    },
    hideFloatSubmenu: function() {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit('hideFloatSubmenu');
      }
    },
    expand: function() {
      if (this.stat == '') {
        this.stat = (this.subIsActive(this.menu.path)) ? 'collapse' : 'expand';
      } else {
        this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
      }
      this.$emit('collapse-other', this.menu);

      if (this.pageOptions.pageSidebarMinified) {
        this.$emit('calcFloatSubmenu');
      }
    },
    handleCalcFloatSubmenu: function() {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit('calcFloatSubmenu');
      }
    },
    collapse: function(menu) {
      if (this.menu != menu) {
        this.stat = 'collapse'
      }
    },
    collapseOther: function() {
      this.$store.dispatch("user/setSelectedID", this.$store.getters.accountID)
      this.$store.dispatch("user/setTier", [])
      this.pageOptions.pageMobileSidebarToggled = false;
      this.pageOptions.pageMobileRightSidebarToggled = false;
      this.$emit('collapse-other', this.menu)
    },
    handleCollapseOther: function(menu) {
      for (var i = 0; i < this.menu.children.length; i++) {
        if(this.$refs.sidebarNavList[i]) {
          this.$refs.sidebarNavList[i].collapse(menu);
        }
      }
    },
    subIsActive(path) {
      const paths = Array.isArray(path) ? path : [path]
      return paths.some(path => {
        return (!['/overview','/accountListAlert','/settings','/messages','/gameRules'].includes(this.$route.path)) ? this.$route.matched[0].path.indexOf(path) === 0 : false
      })
    },
    menuTitle: function(title) {
      switch(title){
        case "forecastHDP":
          return this.$t("ui.forecast") + " " + this.$t("ui.hdp")
        case "forecastHDPMMO":
          return this.$t("ui.forecast") + " " + this.$t("ui.hdp") + " MMO"
        case "forecastOXT":
          return this.$t("ui.forecast") + " " + this.$t("m.BT_1X2")
        case "forecastOU":
          return this.$t("ui.forecast") + " " + this.$t("ui.ou")
        case "forecastOUMMO":
          return this.$t("ui.forecast") + " " + this.$t("ui.ou") + " MMO"
        case "forecastOE":
          return this.$t("ui.forecast") + " " + this.$t("ui.oe")
        default:
          return this.$t(title)
      }
    },
    // getVisible: function(e) {
    //   let accountRole = this.$store.getters.authorityRole
    //   if(accountRole == "SUB_PRI") {
    //     if (e.length > 0) {
    //       let result = false;
    //       let pages = e;
    //       let roles = this.$store.getters.accessRoles.authority_option;
    //       roles = roles.split(',')
    //       for (var i = 0; i < pages.length; i++) {
    //         for (var j = 0; j < roles.length; j++) {
    //           if (roles[j] == pages[i]) {
    //             result = true;
    //             break;
    //           }
    //         }
    //       }
    //       return result;
    //     } else {
    //       return true
    //     }
    //   } else {
    //     return true;
    //   }
    // }
  }
}
</script>
